import EventBus from "@/EventBus";
import axios from 'axios';

const baseUrl = process.env.VUE_APP_API_BASE_URL;
const versionNumber = process.env.VUE_APP_VERSION;

class Axios {
    constructor() {
        axios.defaults.baseURL = baseUrl;
        axios.defaults.headers.common['X-Client-Version'] = versionNumber;
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.interceptors.request.use(config => {
            if (!config.params) {
                config.params = {};
            }
            if (process.env.VUE_APP_SEND_XDEBUG_HEADER) {
                config.params['XDEBUG_SESSION_START'] = 'PHPSTORM';
            }
            return config;
        });

        EventBus().emitter.on('auth.login', user => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.api_token}`;
        });

        EventBus().emitter.on('auth.logout', () => {
            axios.defaults.headers.common['Authorization'] = null;
        });
    }
}
export default Axios;
